export enum ClientNameBackground {
    APT_DRAWING_DONE = "#0f9f0f",
    APT_DRAWING_NOT_DONE = "#e74c3c",
    NOT_APT= "#777"
}